// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Liste des notifications (styles communs dans notifications.css) */

.notifications_page .notifications_list_title {
  font-weight: 600;
  color: var(--text-primary);
}

.notifications_page .notifications_type_chip {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 999px;
  background-color: var(--primary-light);
  color: var(--primary);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

/* le tableau partagé coupe chaque cellule (layout fixe + ellipsis) : ici il prend la largeur nécessaire et défile horizontalement */
.notifications_page .tableau_container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.notifications_page .tableau_table {
  table-layout: auto;
  width: 100%;
}

.notifications_page .tableau_head_item_th,
.notifications_page .tableau_body_item {
  overflow: visible;
  text-overflow: clip;
}

.notifications_page .tableau_body_item:last-child,
.notifications_page .tableau_head_item_th:last-child {
  text-align: right;
}

/* ----- pagination ----- */

.notifications_page .notifications_pager {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 12px;
  font-size: 13px;
  color: var(--text-secondary);
}

/* ----- états vide et erreur ----- */

.notifications_page .notifications_empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 16px;
  text-align: center;
  color: var(--text-secondary);
  border: 1px dashed var(--border);
  border-radius: var(--radius-md);
}

.notifications_page .notifications_empty_title {
  margin: 0;
  font-weight: 600;
  color: var(--text-primary);
}

.notifications_page .notifications_empty_hint {
  margin: 0;
  max-width: 60ch;
  font-size: 13px;
}

.notifications_page .notifications_empty_error {
  color: var(--notifications-danger);
  background-color: var(--danger-light);
  border-style: solid;
  border-color: color-mix(in srgb, var(--notifications-danger) 30%, transparent);
}

.notifications_page .notifications_empty_error .notifications_empty_title {
  color: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/pages/notifications/notificationsList.css"],"names":[],"mappings":"AAAA,oEAAoE;;AAEpE;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;EACtC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oIAAoI;AACpI;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,2BAA2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,4BAA4B;EAC5B,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,mBAAmB;EACnB,8EAA8E;AAChF;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Liste des notifications (styles communs dans notifications.css) */\n\n.notifications_page .notifications_list_title {\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.notifications_page .notifications_type_chip {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 999px;\n  background-color: var(--primary-light);\n  color: var(--primary);\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* le tableau partagé coupe chaque cellule (layout fixe + ellipsis) : ici il prend la largeur nécessaire et défile horizontalement */\n.notifications_page .tableau_container {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.notifications_page .tableau_table {\n  table-layout: auto;\n  width: 100%;\n}\n\n.notifications_page .tableau_head_item_th,\n.notifications_page .tableau_body_item {\n  overflow: visible;\n  text-overflow: clip;\n}\n\n.notifications_page .tableau_body_item:last-child,\n.notifications_page .tableau_head_item_th:last-child {\n  text-align: right;\n}\n\n/* ----- pagination ----- */\n\n.notifications_page .notifications_pager {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 12px;\n  padding-top: 12px;\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n/* ----- états vide et erreur ----- */\n\n.notifications_page .notifications_empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 32px 16px;\n  text-align: center;\n  color: var(--text-secondary);\n  border: 1px dashed var(--border);\n  border-radius: var(--radius-md);\n}\n\n.notifications_page .notifications_empty_title {\n  margin: 0;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.notifications_page .notifications_empty_hint {\n  margin: 0;\n  max-width: 60ch;\n  font-size: 13px;\n}\n\n.notifications_page .notifications_empty_error {\n  color: var(--notifications-danger);\n  background-color: var(--danger-light);\n  border-style: solid;\n  border-color: color-mix(in srgb, var(--notifications-danger) 30%, transparent);\n}\n\n.notifications_page .notifications_empty_error .notifications_empty_title {\n  color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
